import { initializeApp } from "firebase/app";
import "firebase/compat/firestore";
import { getStorage, FirebaseStorage, ref, getDownloadURL, uploadBytes, uploadBytesResumable } from "firebase/storage";
import { EnvValues } from "../interfaces/customTypes/envValues";

let firebaseStorage: undefined | FirebaseStorage;
export const getFirebaseStorage = (config: EnvValues): FirebaseStorage => {
  if (!firebaseStorage) {
    const firebaseConfig = {
      apiKey: config.firebasePublicKey,
      authDomain: `${config.firebaseProjectId}.firebaseapp.com`,
      projectId: config.firebaseProjectId,
      storageBucket: `${config.firebaseProjectId}.appspot.com`,
    };
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    firebaseStorage = getStorage(app);
  }
  return firebaseStorage;
};

export const saveImageToFirebase = async (config: EnvValues, userId: string | number, img: Blob, filename: string) => {
  const [type, format] = img.type.split("/");

  if (!type || type !== "image") {
    throw Error("Invalid file type, expected image");
  }

  const path = `${config.firebaseFolder}/users/${userId}/profiles/${filename}.${format}`;

  const firebaseStorageInstance = getFirebaseStorage(config);
  const storageRef = ref(firebaseStorageInstance, path);

  await uploadBytes(storageRef, img);

  const downloadURL = await getDownloadURL(ref(firebaseStorageInstance, path));

  return downloadURL;
};

export const saveElementToFirebase = async (config: EnvValues, node: string, file: Blob, filename: string) => {
  const [type, format] = file.type.split("/");

  if (!type) {
    throw Error("Invalid file type");
  }

  const path = `${config.firebaseFolder}/${node}/${filename}.${format}`;

  const firebaseStorageInstance = getFirebaseStorage(config);
  const storageRef = ref(firebaseStorageInstance, path);

  await uploadBytes(storageRef, file);

  const downloadURL = await getDownloadURL(ref(firebaseStorageInstance, path));

  return downloadURL;
};

export const saveElementToFirebaseCancellable = (config: EnvValues, node: string, file: Blob, filename: string) => {
  const [type, format] = file.type.split("/");

  if (!type) {
    throw Error("Invalid file type");
  }
  const path = `${config.firebaseFolder}/${node}/${filename}.${format}`;

  const firebaseStorageInstance = getFirebaseStorage(config);
  const storageRef = ref(firebaseStorageInstance, path);
  const uploadTask = uploadBytesResumable(storageRef, file);

  return uploadTask;
};

export const getDownloadURLFirebase = async (
  config: EnvValues,
  node: string,
  file: Blob,
  filename: string
): Promise<string> => {
  const [type, format] = file.type.split("/");

  if (!type) {
    throw Error("Invalid file type");
  }
  const path = `${config.firebaseFolder}/${node}/${filename}.${format}`;
  const firebaseStorageInstance = getFirebaseStorage(config);
  const downloadURL = await getDownloadURL(ref(firebaseStorageInstance, path));

  return downloadURL;
};
